module.exports = __webpack_public_path__ + "img/4.fa389557.jpg";